import { useNode } from "@craftjs/core";
import React from "react";
import { isUpdatedFromDefault } from "../../utils";

import { PencilActiveIcon } from "../../../assets/ui-icons";

import { SpacerInput, TextInput, RangeInput, Tabs } from "./../../ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import RightBar from "../../ui-kit/rightbar";
import { IconPack } from "../../../assets/icon-pack";
import { INPUT_LIMITS } from "../../input-limits";

export const CMSGoogleMapSettings = () => {
  const {
    actions: { setProp },
    props,
    id,
  } = useNode((node) => ({
    text: node.data.props.text,
    props: node.data.props,
  }));

  const { location, maxWidth = "100%", height = "500px" } = props;

  const General = () => {
    return (
      <>
        <SpacerInput>
          <TextInput
            minLength={INPUT_LIMITS["google-map-location"].minlength}
            maxLength={INPUT_LIMITS["google-map-location"].maxlength}
            label="Location"
            value={location}
            onChange={(val) => {
              setProp((props) => {
                props.location = val.target.value;
              });
            }}
          />
          <RangeInput
            resetValue={100}
            // min={5}
            // max={100}
            min={INPUT_LIMITS["cms-google-map-width-height"].min}
            max={INPUT_LIMITS["cms-google-map-width-height"].max}
            step={INPUT_LIMITS["cms-google-map-width-height"].step}
            label="Width"
            value={maxWidth}
            onChange={(val) => {
              setProp((props) => {
                props.maxWidth = val + "%";
              });
            }}
          />
          <RangeInput
            resetValue={100}
            // min={5}
            // max={600}
            min={INPUT_LIMITS["cms-google-map-width-height"].min}
            max={INPUT_LIMITS["cms-google-map-width-height"].max}
            label="Height"
            value={height}
            onChange={(val) => {
              setProp((props) => {
                props.height = val + "px";
              });
            }}
          />
        </SpacerInput>
      </>
    );
  };

  const tabs = [
    {
      label: "General",
      key: "general",
      icon: IconPack.GeneralSettings,
      children: General(),
      isUpdated: isUpdatedFromDefault([]),
    },
  ];

  return (
    <div className="h-full w-[330px] post-edit-right-sidebar p-2 overflow-auto dashboard-ui-scrollbar ">
      <div className="w-full rounded-t-[21px] bg-white">
        <div className="p-5 flex justify-between gap-5">
          <RightBar
            title={"Google Map"}
            icon={
              <FontAwesomeIcon
                icon={faLocationDot}
                size="2xl"
                color="#8402E9"
              />
            }
          />
        </div>
        <Tabs id={`block-cms-settings-tab-${id}`} items={tabs} />
      </div>
    </div>
  );
};
